module.exports = __webpack_public_path__ + "static/helm_of_brilliance-82aa7feed7f2dbe128278aaa1f326cb1.jpeg";